window.$ = window.jQuery = require('jquery');
import setupPhotoswipe from '../modules/create-photoswipe-gallery';

const galleryElements = document.querySelectorAll('.slick-news-gallery');

if (galleryElements.length > 0) {
  galleryElements.forEach(galleryElement => {
    $(galleryElement).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
    setupPhotoswipe(galleryElement);
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/news/show.js